module.exports = __webpack_public_path__ + "static/img/QR-SIAP.ce77207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QR-SIAP.jpg
// module id = 1iQI
// module chunks = 0